import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';

import { CLIENT_STATUS } from '../../../types/Client';

import APIForwarderFormSection from '../../../components/Feature/APIForwarderFormSection';
import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitAPIForwarderFactory, submitWebhookConfigFactory } from '../utils/submit';
import WebhookFormSection from '../../../components/Feature/WebhookFormSection';

const ClientAPIForwarderForm: React.FC = (): React.ReactElement => {
    const {
        client,
        data,
        formConfig,
        isWebhookEnabled,
        isApiForwarderEnabled,
        setIsWebhookEnabled,
        setIsApiForwarderEnabled,
        setData,
    } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        Promise.allSettled([
            submitWebhookConfigFactory(client.id, data.webhook)(form),
            submitAPIForwarderFactory(client.id, data.apiForwarder)(form),
        ]).then(([webhookRes, apiForwarderRes]) => {
            const newData = { ...data };
            if (webhookRes.status === 'fulfilled') newData.webhook = webhookRes.value;
            if (apiForwarderRes.status === 'fulfilled') newData.apiForwarder = apiForwarderRes.value;
            setData(newData);
        });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="webhook" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <>
                                <WebhookFormSection
                                    formInstance={form}
                                    isApiForwarderEnabled={isApiForwarderEnabled}
                                    webhookConfig={data.webhook}
                                    isDetailMode={formConfig.isDetailMode}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    onFeatureStatusChange={(value: boolean): void => {
                                        setIsWebhookEnabled(value);
                                        if (!value) setIsApiForwarderEnabled(false);
                                    }}
                                />
                                <APIForwarderFormSection
                                    formInstance={form}
                                    isWebhookEnabled={isWebhookEnabled}
                                    apiForwarderConfig={data.apiForwarder}
                                    isDetailMode={formConfig.isDetailMode}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    onFeatureStatusChange={(value: boolean): void => setIsApiForwarderEnabled(value)}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientAPIForwarderForm;
